export enum MazMessageSender {
  user = 'user',
  assistant = 'assistant',
  system = 'system', // used for GPT prompting and shouldn't be shown to the user
}
